// extracted by mini-css-extract-plugin
module.exports = {"avatar":"AvatarImage_avatar__aF6rK","fallbackIconHolder":"AvatarImage_fallbackIconHolder__1CMB8","fallbackIcon":"AvatarImage_fallbackIcon__1VTFh"};